import React, { useEffect, useMemo } from "react"
import MiddleChart from "components/molecules/chart/middleChart"
import uuid from "uuid"
import { APIResponse } from "redux/apis/types"
import { isEmpty, get } from "lodash"
import store from "redux/store"
import { changeSymbol } from "redux/ducks/Chart"
import { InfoTable } from "components/molecules/table"
import { infoTableColumns } from "config/table_columns"
import { useSelector } from "react-redux"
import { refreshSymbol } from "../../../../redux/ducks/SymbolDetail"
import { pageLoadRegist } from "../../../../redux/ducks/PageLoad"

export const Chart = (symbolDetail: APIResponse.Res) => {
  const canvasId = useMemo(() => {
    return uuid()
  }, [])

  useEffect(() => {
    if (isEmpty(symbolDetail)) return
    store.dispatch(
      changeSymbol(canvasId, get(symbolDetail, "symbolDetail.Symbol"))
    )
  }, [symbolDetail])

  return (
    <div className="panel-chart">
      <MiddleChart id={canvasId} notShowPriceDetail={true} />
      <InfoTable
        list={infoTableColumns.indicative}
        data={get(symbolDetail, "symbolDetail.Symbol")}
        className="table-striped table-index-detail"
        wrapperCls="index-detail-table-row"
      />
    </div>
  )
}
